// File: frontend/src/components/teams/TeamList.tsx
// src/components/teams/TeamList.tsx

import React from "react";
import { useTranslation } from "react-i18next";
import { TeamModel } from "../../models/TeamModel";
import { TeamRow } from "./TeamRow";
// Sitewide pins: badge wrapper for the admin-pinned topic row
import { PinnedTopicWrap } from "../common/PinnedTopicWrap";

interface TeamListProps {
  teams: TeamModel[];
  selectedTeamId: number | null;
  onSelectTeam: (teamId: number) => void;
  // Forwarded to each TeamRow for mobile pane switching
  onMobileNavigate?: () => void;
  // ID of the admin-pinned team (null = nothing pinned)
  pinnedTeamId?: number | null;
}

export const TeamList: React.FC<TeamListProps> = ({ teams, selectedTeamId, onSelectTeam, onMobileNavigate, pinnedTeamId = null }) => {
  const { t } = useTranslation();

  if (!teams || teams.length === 0) {
    return (
      <div className="person-list__empty">
        <p>{t("teams_not_found", "Takım bulunamadı.")}</p>
      </div>
    );
  }

  return (
    <div className="person-list">
      {teams.map(team => (
        <PinnedTopicWrap key={team.id} pinned={team.id === pinnedTeamId}>
        <TeamRow
          team={team}
          isSelected={team.id === selectedTeamId}
          onSelect={() => onSelectTeam(team.id)}
          onMobileNavigate={onMobileNavigate}
        />
        </PinnedTopicWrap>
      ))}
    </div>
  );
};